export default __webpack_public_path__ + "c06e3fcfd0336a8cc7130d564fcace82.svg";